import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchRepatriationsTransactionsConfirm = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'confirmRepatriationsTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.post(serviceUrl, {
    description: payload.params.description,
    plannedArrivalDateTime: moment(payload.params.plannedArrivalDateTime).format('YYYY-MM-DD HH:mm:ss'),
    quantityConfirmed: payload.params.quantityConfirmed,
    transactionId: payload.params.transactionId,
  });
};

export default apiFetchRepatriationsTransactionsConfirm;
